import React from 'react';
import './Button.scss';

interface ButtonProps {
    variant: 'primary' | 'secondary' | 'danger';
    title: string;
    icon?: React.JSX.Element | null;
    onClick?: any;
    disabled?: boolean;
    type?: 'button' | 'submit';
}

const Button: React.FC<ButtonProps> = ({variant, title, icon, onClick, disabled, type}) => {


    return (
        <button type={type || 'submit'} disabled={disabled} onClick={onClick} className={`button ${variant} ${disabled ? 'disabled' : ''}`}>
            {title}
            {icon && icon}
        </button>
    );
};

export default Button;
